import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@images/download-icon2.png'
import _imports_1 from '@images/download-icon1.png'
import _imports_2 from '@images/download-icon3.png'


const _hoisted_1 = { class: "download" }
const _hoisted_2 = { class: "center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "left" }, [
  /*#__PURE__*/_createVNode("div", { class: "title" }, "应用下载"),
  /*#__PURE__*/_createVNode("div", { class: "sub-title" }, "Application download")
], -1)
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { class: "list-wrap" }
const _hoisted_6 = {
  key: 0,
  class: "list-icon",
  src: _imports_0
}
const _hoisted_7 = {
  key: 1,
  class: "list-icon",
  src: _imports_0
}
const _hoisted_8 = {
  key: 2,
  class: "list-icon",
  src: _imports_1
}
const _hoisted_9 = {
  key: 3,
  class: "list-icon",
  src: _imports_2
}
const _hoisted_10 = { class: "info" }
const _hoisted_11 = { class: "info-name" }
const _hoisted_12 = {
  key: 0,
  class: "info-apply"
}
const _hoisted_13 = { class: "info-edition" }
const _hoisted_14 = {
  key: 0,
  class: "info-edition-text",
  target: ""
}
const _hoisted_15 = { class: "info-edition-btn" }
const _hoisted_16 = {
  key: 0,
  class: "sub-text mt-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "list",
              key: index
            }, [
              (index == 0)
                ? (_openBlock(), _createBlock("img", _hoisted_6))
                : _createCommentVNode("", true),
              (index == 1)
                ? (_openBlock(), _createBlock("img", _hoisted_7))
                : _createCommentVNode("", true),
              (index == 2)
                ? (_openBlock(), _createBlock("img", _hoisted_8))
                : _createCommentVNode("", true),
              (index == 3)
                ? (_openBlock(), _createBlock("img", _hoisted_9))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_10, [
                _createVNode("span", _hoisted_11, _toDisplayString(item.name), 1),
                (item.require)
                  ? (_openBlock(), _createBlock("span", _hoisted_12, "组件要求：" + _toDisplayString(item.require), 1))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", null, [
                    (item.url)
                      ? (_openBlock(), _createBlock("span", _hoisted_14, " 当前版本：" + _toDisplayString(item.editionName), 1))
                      : _createCommentVNode("", true),
                    _createVNode("a", {
                      href: item.url || 'javascript:;',
                      download: item.desc
                    }, [
                      _createVNode("span", _hoisted_15, _toDisplayString(item.btnTxt), 1)
                    ], 8, ["href", "download"])
                  ]),
                  (item.update)
                    ? (_openBlock(), _createBlock("div", _hoisted_16, " 更新时间： " + _toDisplayString(item.update || ""), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}